var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 150,
    viewBox: "0 0 110 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "firebase"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_224_36",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 150
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M95.0289 33.5789C94.688 31.7039 92.9834 30.5107 91.1084 30.7664C90.4266 30.8516 89.7448 31.1925 89.2334 31.7039L71.506 49.4313L57.6139 22.9255C56.7617 21.2209 54.7162 20.6243 53.0116 21.4766C52.415 21.8175 51.9037 22.3289 51.5628 22.9255L43.9775 37.4142L24.8865 1.78898C24.0342 0.169656 21.9035 -0.512164 20.2842 0.425341C19.3467 0.936707 18.6649 1.87421 18.4944 2.89695L0 121.023L49.3468 148.722C52.415 150.426 56.2503 150.426 59.3185 148.722L109.091 121.023L95.0289 33.5789Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_224_36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 121.023L18.4944 2.8969C18.7501 1.02189 20.5399 -0.256529 22.4149 0.0843815C23.4376 0.254837 24.3751 0.936657 24.8865 1.87416L43.9775 37.4994L51.5628 23.0106C52.415 21.3061 54.4605 20.7095 56.1651 21.5618C56.7617 21.9027 57.273 22.414 57.6139 23.0106L109.091 121.023H0Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.12,
    d: "M63.0689 0.851647L-27.2725 -6.81885V156.818L0.000413331 121.023L63.0689 0.851647Z",
    fill: "url(#paint0_linear_224_36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M63.8356 74.9995L43.9775 37.4141L0 121.022L63.8356 74.9995Z",
    fill: "#F57C00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M-27.2725 -6.81885H136.365V156.818H-27.2725V-6.81885Z",
    fill: "url(#paint1_linear_224_36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M109.091 121.022L94.9437 33.4934C94.6028 31.6184 92.8982 30.4252 91.0232 30.6809C90.3414 30.7661 89.6595 31.107 89.1482 31.6184L0 121.022L49.3468 148.721C52.415 150.426 56.2503 150.426 59.3185 148.721L109.091 121.022Z",
    fill: "#FFCA28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M95.0292 33.5789C94.6883 31.7039 92.9837 30.5107 91.1087 30.7664C90.4269 30.8516 89.7451 31.1925 89.2337 31.7039L71.5063 49.4313L57.6142 22.9255C56.7619 21.2209 54.7165 20.6243 53.0119 21.4766C52.4153 21.8175 51.904 22.3289 51.563 22.9255L43.9778 37.4142L24.8868 1.78898C24.0345 0.169656 21.9038 -0.512164 20.2845 0.425341C19.347 0.936707 18.6651 1.87421 18.4947 2.89695L0.00027198 121.023H-0.0849609L0.00027198 121.108L0.511637 121.363L71.5063 50.2836L89.2337 32.5562C90.5973 31.1925 92.728 31.1925 94.0917 32.5562C94.603 33.0676 94.9439 33.6641 95.0292 34.4312L109.007 121.108L109.177 121.023L95.0292 33.5789ZM0.170725 120.852L18.4947 3.74922C18.7504 1.87421 20.5401 0.595795 22.4152 0.936706C23.4379 1.10716 24.3754 1.78898 24.8868 2.72649L43.9778 38.3517L51.563 23.863C52.4153 22.1584 54.4608 21.5618 56.1653 22.4141C56.7619 22.755 57.2733 23.2664 57.6142 23.863L71.2506 49.7722L0.170725 120.852Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.2,
    d: "M59.3185 147.87C56.2503 149.574 52.415 149.574 49.3468 147.87L0.0852264 120.256L0 121.023L49.3468 148.722C52.415 150.426 56.2503 150.426 59.3185 148.722L109.091 121.023L109.006 120.256L59.3185 147.87Z",
    fill: "#A52714"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M95.0289 33.5789C94.688 31.7039 92.9834 30.5107 91.1084 30.7664C90.4266 30.8516 89.7448 31.1925 89.2334 31.7039L71.506 49.4313L57.6139 22.9255C56.7617 21.2209 54.7162 20.6243 53.0116 21.4766C52.415 21.8175 51.9037 22.3289 51.5628 22.9255L43.9775 37.4142L24.8865 1.78898C24.0342 0.169656 21.9035 -0.512164 20.2842 0.425341C19.3467 0.936707 18.6649 1.87421 18.4944 2.89695L0 121.023L49.3468 148.722C52.415 150.426 56.2503 150.426 59.3185 148.722L109.091 121.023L95.0289 33.5789Z",
    fill: "url(#paint2_linear_224_36)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_36",
    x1: 21.2578,
    y1: 80.5866,
    x2: 14.4396,
    y2: 77.0241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A52714",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_36",
    x1: 50.2345,
    y1: 70.6676,
    x2: 47.1833,
    y2: 67.6164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A52714",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_36",
    x1: -2.93701,
    y1: 26.3964,
    x2: 111.001,
    y2: 140.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.457c81c1c5708e3f5218cd75225616c0.svg";
export { ForwardRef as ReactComponent };